import { productUrl } from "@elyxeer/ui";

import { onNextResume } from "~/lib/capacitor";
import { openExternal } from "~/lib/external-link";
import { useAuthStore } from "~/store/auth-store";

/**
 * Open the supplement's product page on elyxeer.com and refresh membership when the
 * member returns.
 *
 * The app sells nothing itself: Elyxeer 30.5 is a physical product, ordered on the
 * storefront like any other, and the app access comes with the subscription. So the
 * paywall and the plan cards hand over to the product page rather than to a checkout
 * they would have to assemble. Shared by both, so they can never drift apart.
 */
export function useProductPage() {
  const refreshMembership = useAuthStore((state) => state.refreshMembership);

  return async (handle: string | null | undefined) => {
    await openExternal(productUrl(handle));
    // No callback URL exists — returning to the app is the one signal the member
    // may have subscribed, so re-read /auth/me then (webhook lag permitting).
    onNextResume(() => void refreshMembership());
  };
}
